import { addDays, subDays } from "date-fns";
import { useCallback, useState } from "react";

import { type DateTimeSlot } from "../types";

export function useTimeSlot({
  initialValue,
  onChange,
}: {
  initialValue: DateTimeSlot;
  onChange?: (dateTimeSlot: DateTimeSlot) => void;
}) {
  const [dateTimeSlot, setDateTimeSlot] = useState(initialValue);

  const incrementTimeSlot = useCallback(() => {
    let newDateTimeSlot: DateTimeSlot;
    // eslint-disable-next-line default-case
    switch (dateTimeSlot.timeSlot) {
      case "am": {
        newDateTimeSlot = { ...dateTimeSlot, timeSlot: "pm" };
        break;
      }

      case "pm": {
        newDateTimeSlot = { ...dateTimeSlot, timeSlot: "noc" };
        break;
      }

      case "noc": {
        newDateTimeSlot = { date: addDays(dateTimeSlot.date, 1), timeSlot: "am" };
        break;
      }
    }

    setDateTimeSlot(newDateTimeSlot);
    onChange?.(newDateTimeSlot);
  }, [dateTimeSlot, onChange]);

  const decrementTimeSlot = useCallback(() => {
    let newDateTimeSlot: DateTimeSlot;
    // eslint-disable-next-line default-case
    switch (dateTimeSlot.timeSlot) {
      case "am": {
        newDateTimeSlot = { date: subDays(dateTimeSlot.date, 1), timeSlot: "noc" };
        break;
      }

      case "pm": {
        newDateTimeSlot = { ...dateTimeSlot, timeSlot: "am" };
        break;
      }

      case "noc": {
        newDateTimeSlot = { ...dateTimeSlot, timeSlot: "pm" };
        break;
      }
    }

    setDateTimeSlot(newDateTimeSlot);
    onChange?.(newDateTimeSlot);
  }, [dateTimeSlot, onChange]);

  return { dateTimeSlot, incrementTimeSlot, decrementTimeSlot } as const;
}
